<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      authId: window.localStorage.getItem('authId') || null,
      onlineUsers: null
    }
  },
  created () {

    if (!this.authId) {
      axios.get('/auth').then(response => {
        this.authId = response.data.user.id

        window.localStorage.setItem('authId', response.data.user.id)

        this.connect()
      })

    } else {
      this.connect()
    }
  },
  methods: {
    connect () {
      Echo.connector.pusher.config.auth.headers['Authorization'] = this.authId

      Echo.join('strangerchat')
        .here((users) => {
          this.onlineUsers = users.length
        })

        .joining((user) => {
          this.onlineUsers++
        })

        .leaving((user) => {
          this.onlineUsers--
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue